import { State } from '../../types';

export const iowa: State = {
  name: 'Iowa',
  abbreviation: 'IA',
  terms: [
    {
      word: 'Adel',
      phonetic: 'ay-DELL',
      // audioUrl: '/audio/adel.mp3',
      description: 'A city in Dallas County, often mispronounced by non-locals.'
    },
    {
      word: 'Buena Vista',
      phonetic: 'BYOO-nuh VIH-stuh',
      // audioUrl: '/audio/buena_vista.mp3',
      description: 'A county in northwestern Iowa, name of Spanish origin.'
    },
    {
      word: 'Camanche',
      phonetic: 'cah-MANCH',
      // audioUrl: '/audio/camanche.mp3',
      description: 'A city along the Mississippi River, often mispronounced due to its spelling.'
    },
    {
      word: 'Chillicothe',
      phonetic: 'chill-uh-KAW-thee',
      // audioUrl: '/audio/chillicothe.mp3',
      description: 'A small community in Wapello County with a name of Native American origin.'
    },
    {
      word: 'Des Moines',
      phonetic: 'duh-MOYN',
      // audioUrl: '/audio/desmoines.mp3',
      description: 'Capital city of Iowa'
    },
    {
      word: 'Guttenberg',
      phonetic: 'GUT-in-berg',
      // audioUrl: '/audio/guttenberg.mp3',
      description: 'A city named after Johannes Gutenberg, often mispronounced by visitors.'
    },
    {
      word: 'Keosauqua',
      phonetic: 'Kee-o-saw-kwah',
      // audioUrl: '/audio/desmoines.mp3',
      description: 'A small town named after the Native word "Big Bend" for being located on a curve of Des Moines River.'
    },
    {
      word: 'Monticello',
      phonetic: 'MONTI-CHELLO',
      // audioUrl: '/audio/monticello.mp3',
      description: 'A city in Jones County, sharing its name with Thomas Jefferson\'s estate.'
    },
    {
      word: 'Nevada',
      phonetic: 'neh-VAY-duh',
      // audioUrl: '/audio/nevada-ia.mp3',
      description: 'City in central Iowa (different from the state pronunciation)'
    },
    {
      word: 'Osceola',
      phonetic: 'oh-see-OH-luh',
      // audioUrl: '/audio/osceola.mp3',
      description: 'A city in Clarke County, named after the Seminole leader.'
    },
    {
      word: 'Quasqueton',
      phonetic: 'kwah-skwuh-TON',
      // audioUrl: '/audio/quasqueton.mp3',
      description: 'A small city in Buchanan County, with a name challenging to pronounce.'
    },
    {
      word: 'Tripoli',
      phonetic: 'trih-POH-luh',
      // audioUrl: '/audio/tripoli.mp3',
      description: 'A city in Bremer County, sharing its name with the capital of Libya.'
    },
    {
      word: 'Waukee',
      phonetic: 'wah-KEE',
      // audioUrl: '/audio/waukee.mp3',
      description: 'A rapidly growing city in Dallas County, often mispronounced by newcomers.'
    },
    {
      word: 'What Cheer',
      phonetic: 'WAT-cheer',
      // audioUrl: '/audio/what_cheer.mp3',
      description: 'A city in Keokuk County with a unique name, often leading to pronunciation challenges.'
    }
  ]
};